import type { StreamConfig } from '../types/stream';

// Rotate a full-screen element via CSS transform, swapping width/height for
// 90/270 so it still fills the screen. Used for both the pairing UI (so an
// installer sees the chosen orientation) and the player stage.
export function applyRotation(el: HTMLElement, rotationDeg: number): void {
  const rotation = (((rotationDeg % 360) + 360) % 360);

  if (rotation === 90 || rotation === 270) {
    el.style.width = '100vh';
    el.style.height = '100vw';
    el.style.left = '50%';
    el.style.top = '50%';
    el.style.right = 'auto';
    el.style.bottom = 'auto';
    el.style.transform = `translate(-50%, -50%) rotate(${rotation}deg)`;
  } else {
    el.style.width = '';
    el.style.height = '';
    el.style.left = '';
    el.style.top = '';
    el.style.right = '';
    el.style.bottom = '';
    el.style.transform = rotation === 180 ? 'rotate(180deg)' : '';
  }
}

// Apply screen-level config to the stage element: rotation via CSS transform and
// brightness via a filter. Mirrors applyRotation/applyBrightness from Android.
// The final rotation combines the local physical-install rotation (set at pairing)
// with the dashboard's config.rotation, so both still take effect.
export function applyStageConfig(
  stage: HTMLElement,
  config: StreamConfig,
  localRotation = 0,
): void {
  const effective = (config.rotation + localRotation) % 360;
  applyRotation(stage, effective);

  const brightness = Math.min(100, Math.max(10, config.brightness)) / 100;
  stage.style.filter = `brightness(${brightness})`;
}
